import videocallshopApi from '../apis/videocallshop';

import { toastr } from 'react-redux-toastr';

import {
    STORES_FETCH_REQUESTED,
    STORES_FETCH_SUCCESS,
    STORES_FETCH_FAILED
} from './types';

export const fetchStores = () => async (
    dispatch,
    getState
) => {
    dispatch({
        type: STORES_FETCH_REQUESTED,
    });

    try {
        let { data } = await videocallshopApi.get('/stores');

        dispatch({
            type: STORES_FETCH_SUCCESS,
            payload: data.data
        });
   } catch (err) {
    dispatch({
      type: STORES_FETCH_FAILED,
    });

    // 1. Esto te va a mostrar el error real en la consola (F12)
    console.error("Error completo al cargar tiendas:", err);
    
    // 2. Si el error viene del backend, esto te muestra el status (ej. 404, 500)
    if (err.response) {
       console.error("Data del error:", err.response.data);
       console.error("Status del error:", err.response.status);
    }

    toastr.error(
      'Error de conexión',
      'No se pudieron cargar las tiendas. Revisá la consola.'
    );
  }
}